var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBa(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 54,
    height: 40,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.3 0h53.4v40H.3z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#009",
    d: "M.3 0h53.4v40H.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m11.4 0 40 40V0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M41.4 37.6 39.2 36 37 37.6l.8-2.6-2.2-1.6h2.7l.9-2.6.8 2.6h2.7L40.6 35zm6.3.8H45l-.9-2.6-.8 2.6h-2.7l2.2 1.6-.9 2.6 2.3-1.6 2.2 1.6-.9-2.6zm-12.1-8.3 2.1-1.7H35l-.8-2.6-.9 2.6h-2.7l2.2 1.6-.8 2.6 2.2-1.6 2.2 1.6zm-5-5 2.1-1.7H30l-.8-2.6-.9 2.6h-2.7l2.2 1.6-.9 2.6 2.3-1.6 2.2 1.6zm-5-5 2.1-1.7H25l-.8-2.6-.9 2.6h-2.7l2.2 1.6-.8 2.6 2.2-1.6 2.2 1.6zm-5-5 2.1-1.7H20l-.9-2.6-.8 2.6h-2.7l2.2 1.6-.9 2.6 2.3-1.6 2.2 1.6zm-5-5 2.1-1.7H15l-.8-2.6-.9 2.6h-2.7l2.2 1.6-.8 2.6 2.2-1.6 2.2 1.6zm-5-5 2.1-1.7H10L9.2.8l-.9 2.6H5.6L7.8 5 7 7.6 9.2 6l2.2 1.6zm-5-5 2.1-1.7H5l-.8-2.6-.9 2.6H.6L2.8 0 2 2.6 4.2 1l2.2 1.6z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.3 0h53.3v40H.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBa);
export default __webpack_public_path__ + "static/media/ba.444cad5a01008b5725438caf685633a8.svg";
export { ForwardRef as ReactComponent };